export const FILE_TYPES = [
    ".dita",
    ".ditamap",
    ".doc",
    ".docx",
    ".htm",
    ".html",
    ".idml",
    ".mi2",
    ".mif",
    ".odf",
    ".odp",
    ".ods",
    ".odt",
    ".po",
    ".ppt",
    ".pptx",
    ".srt",
    ".txt",
    ".xliff",
    ".xls",
    ".xlsx",
    ".xlt",
    ".xml",
    ".zip"
];
